<template>
  <div class="flex flex-col gap-1">
    <h3 class="text-title-medium">{{ title }}</h3>
    <div
      v-if="questions.length == 0"
      class="rounded-small border-outline-variant flex w-full items-center justify-center border p-4"
    >
      <span class="text-body-medium text-on-surface-variant">Nichts ausgewählt</span>
    </div>
    <ul class="flex grow flex-col justify-start gap-1">
      <li
        v-for="question in questions"
        :key="question.question.id"
        class="rounded-small border-outline-variant flex break-inside-avoid flex-col border p-2"
      >
        <h4 class="text-body-medium">{{ question.question.content }}</h4>
        <PerspectiveValueBar
          :perspectives="perspectiveBarEntries(question)"
          :topic-perspectives="topicPerspectives"
          :disable-animation="true"
        />
      </li>
    </ul>
  </div>
</template>
<script lang="ts" setup>
  import PerspectiveValueBar from '@/core/components/analytics/question-list/PerspectiveValueBar.vue'
  import type { Perspective } from '@/core/models/perspective'
  import { toValueBarPerspectives } from '@/core/models/perspective-analysis'
  import type { QuestionAnalysis } from '@/core/models/surveys-analytics'
  interface Props {
    title: string
    questions: ReadonlyArray<QuestionAnalysis>
    topicPerspectives: ReadonlyArray<Perspective>
  }
  const props = defineProps<Props>()

  const perspectiveBarEntries = (question: QuestionAnalysis) =>
    toValueBarPerspectives(question.perspectives, props.topicPerspectives)
</script>
